import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import type { ExportPreviewContextType } from '../types/context.types';

const ExportPreviewContext = createContext<ExportPreviewContextType | undefined>(undefined);

export const useExportPreview = () => {
  const context = useContext(ExportPreviewContext);
  if (!context) throw new Error('useExportPreview must be used within ExportProvider.');
  return context;
};

export const ExportPreviewProvider = ({
  children,
  value
}: {
  children: ReactNode;
  value: ExportPreviewContextType;
}) => {
  return <ExportPreviewContext.Provider value={value}>{children}</ExportPreviewContext.Provider>;
};
